export const getFormattedPrice = (fee: number, currency: string, locale?: string | null) => {
  const formatter = new Intl.NumberFormat(locale || 'en-US', {
    style: 'currency',
    currency,
  })

  return formatter.format(fee)
}
